export enum SessionStatus
{
    Active,
    Ended,
}